import { appData } from '@/mocks/homeData';

export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="bg-gradient-to-br from-background-100 to-background-100 rounded-2xl border border-background-200/60 overflow-hidden">
          <div className="flex flex-col lg:flex-row items-center">
            <div className="flex-1 p-8 md:p-12 lg:p-14">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
                移动观影
              </h2>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed max-w-[500px]">
                {appData.description}
              </p>

              <div className="mt-6 grid grid-cols-3 gap-3 max-w-[360px]">
                {appData.features.map((feature) => (
                  <span
                    key={feature}
                    className="px-3 py-2 bg-background-50 rounded-lg text-xs text-foreground-600 text-center border border-background-200/60"
                  >
                    {feature}
                  </span>
                ))}
              </div>

              <div className="mt-7 flex flex-wrap gap-3">
                {appData.platforms.map((platform) => (
                  <button
                    key={platform.name}
                    className="flex items-center gap-2 px-5 py-2.5 bg-foreground-950 text-background-50 hover:bg-foreground-800 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer"
                  >
                    <i className={`${platform.icon} text-base`}></i>
                    {platform.name} 版下载
                  </button>
                ))}
              </div>

              <p className="mt-4 text-xs text-foreground-500">
                扫码或点击按钮下载，支持 Android / iOS / Windows
              </p>
            </div>

            <div className="flex-1 flex items-center justify-center p-8 md:p-12">
              <div className="relative w-[200px] h-[200px] md:w-[240px] md:h-[240px] bg-background-50 rounded-3xl border border-background-200/60 flex items-center justify-center">
                <div className="text-center">
                  <i className="ri-qr-code-line text-5xl text-primary-500"></i>
                  <p className="mt-3 text-xs text-foreground-500">扫码下载APP</p>
                  <p className="mt-1 text-[11px] text-foreground-400">无极电影网 移动客户端</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}